import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      if (!hash || !hash.includes('session_id=')) {
        navigate('/dashboard');
        return;
      }

      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      if (!sessionId) {
        navigate('/dashboard');
        return;
      }

      try {
        const response = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        login(response.data.user, response.data.session_token);
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Session exchange failed:', error);
        navigate('/');
      }
    };

    processSession();
  }, [location.hash, navigate, login]);

  return (
    <div className="min-h-screen bg-[#15161B] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-2 border-[#B89762]/40 border-t-transparent"></div>
        <p className="mt-4 text-sm text-gray-400 font-medium uppercase tracking-widest">Processing...</p>
      </div>
    </div>
  );
};

export default AuthCallback;